import Store from './Store'
import Actions from './Actions'
import Service from './Service'
import Constants from './Constants'

export {
   Store as DeviceStore,
   Actions as DeviceActions,
   Service as DeviceService,
   Constants as DeviceConstants
}



// WEBPACK FOOTER //
// lib/api/device/index.js